import { createAsyncThunk } from "@reduxjs/toolkit";
import genericUtility from "../../services/utility/GenericUtility";
import ProductApiService from "../apiServices/ProductApiService";

// Thunk to fetch and update MyListings from www.sample.com
export const fetchMyListings = createAsyncThunk(
  "productList/fetchMyListings",
  async (
    {
      userId,
      ignoreProductIds,
    }: {
      userId: string;
      ignoreProductIds: string[];
    }
  ) => {
    const response: any =
      await ProductApiService.getProductsByUserIdsInBatch(
        userId,
        ignoreProductIds
      );

    const ProductDictionary = genericUtility.listToDictionary(
      response.contents[0]?.products ?? []
    );

    // 🔑 IMPORTANT: return ONLY dictionary
    return ProductDictionary;
  }
);

export const fetchUserListings = createAsyncThunk(
  "productList/fetchUserListings",
  async ({ userId, ids }: { userId: string; ids: string[] }) => {
    const response: any = await ProductApiService.getProductsByUserIdsInBatch(userId, ids);
    const ProductDictionary = genericUtility.listToDictionary(
      response.contents[0]?.products ?? [],
    );
    return {
      products: ProductDictionary,
      fetchCount: response.contents[0]?.fetchCount || 0,
      totalCount: response.contents[0]?.totalCount ?? response.contents[0]?.fetchCount ?? 0
    };
  },
);

const MyListingsThunk = { fetchMyListings, fetchUserListings };
export default MyListingsThunk;
